<div class="admin-panel">
  <h1>Error Leads</h1>

  @if (errorLeads().length === 0) {
    <div class="no-leads">
      <p>No leads with error status found</p>
    </div>
  } @else {
    <table mat-table [dataSource]="errorLeads()">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let lead">{{ lead.id }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let lead">{{ lead.name }}</td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>Category</th>
        <td mat-cell *matCellDef="let lead">{{ lead.leadCategory }}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>Address</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.address.street }} {{ lead.address.houseNumber }},
          {{ lead.address.postalCode }} {{ lead.address.city }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let lead">{{ lead.email || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let lead">{{ lead.tel || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef>Website</th>
        <td mat-cell *matCellDef="let lead">{{ lead.website || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let lead">
          <button
            mat-raised-button
            color="primary"
            (click)="retryLead(lead.id)"
            [disabled]="retryingLeadId !== null">
            @if (isRetrying(lead.id)) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              Retry
            }
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</div>
